module.exports = __webpack_public_path__ + "img/image04.405b3ba3.jpg";